// extracted by mini-css-extract-plugin
module.exports = {"record":"Rule_record_iPs8D","back":"Rule_back_9NCc1"};